import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard,
  Users,
  UserCog,
  Award,
  FileText,
  ListChecks,
  Settings,
  LogOut,
  Heart,
} from "lucide-react";

const adminNav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/admin/leads", label: "Leads", icon: Users, testid: "nav-leads" },
  { to: "/admin/applications", label: "Applications", icon: Award, testid: "nav-applications" },
  { to: "/admin/partners", label: "Partners", icon: UserCog, testid: "nav-partners" },
  { to: "/admin/articles", label: "Articles", icon: FileText, testid: "nav-articles-cms" },
  { to: "/admin/quiz", label: "Quiz", icon: ListChecks, testid: "nav-quiz-cms" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

const partnerNav = [
  { to: "/partner", label: "My Leads", icon: Users, end: true, testid: "nav-partner-leads" },
];

export default function DashSidebar({ role }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = role === "admin" ? adminNav : partnerNav;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <aside className="fixed lg:static inset-y-0 left-0 z-30 w-64 bg-white border-r border-[#E2DFD8] flex flex-col">
      <div className="p-6 border-b border-[#E2DFD8]">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full bg-[#2C4C3B] flex items-center justify-center">
            <Heart className="w-5 h-5 text-[#F7F5F0]" fill="currentColor" />
          </div>
          <div>
            <div className="font-display text-lg font-semibold text-[#2C4C3B] leading-tight">CareHome</div>
            <div className="text-xs text-[#5C6B62] -mt-0.5">{role === "admin" ? "Admin" : "Partner"}</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 p-4 space-y-1 thin-scroll overflow-y-auto">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={item.testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition ${
                isActive
                  ? "bg-[#2C4C3B] text-white"
                  : "text-[#5C6B62] hover:bg-[#9CAF88]/10 hover:text-[#2C4C3B]"
              }`
            }
          >
            <item.icon className="w-4 h-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-[#E2DFD8]">
        <div className="mb-3 px-2">
          <div className="text-sm font-medium text-[#2C4C3B]">{user?.name}</div>
          <div className="text-xs text-[#5C6B62] truncate">{user?.email}</div>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 w-full px-4 py-2.5 rounded-xl text-sm text-[#5C6B62] hover:bg-[#E07A5F]/10 hover:text-[#E07A5F] transition"
          data-testid="logout-button"
        >
          <LogOut className="w-4 h-4" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
